import { createStore, combineReducers} from "redux";
import sesion from "./reducers/sesion";
import ventasDashboard from "./ventasDashboardReducer";

export default createStore(
    combineReducers({
        sesion,
        ventasDashboard
    })
);